/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Selectallapply2Inputs */

const en_questionnaire_selectallapply2 = /** @type {(inputs: Questionnaire_Selectallapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all that apply`)
};

const fr_questionnaire_selectallapply2 = /** @type {(inputs: Questionnaire_Selectallapply2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner tout les choix qui s'appliquent`)
};

/**
* | output |
* | --- |
* | "Select all that apply" |
*
* @param {Questionnaire_Selectallapply2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_selectallapply2 = /** @type {((inputs?: Questionnaire_Selectallapply2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Selectallapply2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_selectallapply2(inputs)
	return fr_questionnaire_selectallapply2(inputs)
});
export { questionnaire_selectallapply2 as "questionnaire_selectAllApply" }